const SAVED_PINS_KEY = 'mri_saved_room_pins'

function sanitizeCode(code: string): string {
    return (code || '').toUpperCase().trim()
}

export function getSavedPin(code: string): string | undefined {
    if (typeof window === 'undefined') return undefined
    try {
        const raw = localStorage.getItem(SAVED_PINS_KEY)
        if (!raw) return undefined
        const map = JSON.parse(raw) as Record<string, string>
        return map[sanitizeCode(code)]
    } catch {
        return undefined
    }
}

export function savePin(code: string, pin: string): void {
    if (typeof window === 'undefined') return
    try {
        const cleanCode = sanitizeCode(code)
        if (!cleanCode) return
        const raw = localStorage.getItem(SAVED_PINS_KEY)
        const map = raw ? (JSON.parse(raw) as Record<string, string>) : {}
        map[cleanCode] = pin.trim()
        localStorage.setItem(SAVED_PINS_KEY, JSON.stringify(map))
    } catch {
        // Nada
    }
}

export function removeSavedPin(code: string): void {
    if (typeof window === 'undefined') return
    try {
        const cleanCode = sanitizeCode(code)
        if (!cleanCode) return
        const raw = localStorage.getItem(SAVED_PINS_KEY)
        if (!raw) return
        const map = JSON.parse(raw) as Record<string, string>
        delete map[cleanCode]
        localStorage.setItem(SAVED_PINS_KEY, JSON.stringify(map))
    } catch {
        // Nada
    }
}

/** Existe algum PIN guardado neste navegador? Controla se o botao "esquecer" aparece. */
export function hasSavedPins(): boolean {
    if (typeof window === 'undefined') return false
    try {
        const raw = localStorage.getItem(SAVED_PINS_KEY)
        if (!raw) return false
        const map = JSON.parse(raw) as Record<string, string>
        return Object.keys(map).length > 0
    } catch {
        return false
    }
}

/** Apaga TODOS os PINs salvos deste navegador — o botao "esquecer este dispositivo". */
export function clearSavedPins(): void {
    if (typeof window === 'undefined') return
    try {
        localStorage.removeItem(SAVED_PINS_KEY)
    } catch {
        // Nada
    }
}
